export enum MimeType {
    pptx = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    docx = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    // ppt = "application/vnd.ms-powerpoint",
    xls = "application/vnd.ms-excel",
    // doc = "application/msword",
    pdf = "application/pdf",
    txt = "text/plain",
    csv = "text/csv",
    mp3 = "audio/mpeg",
    mp4 = "video/mp4"
}

export enum TrialMimeType {
    pptx = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    docx = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    // ppt = "application/vnd.ms-powerpoint",
    xls = "application/vnd.ms-excel",
    // doc = "application/msword",
    pdf = "application/pdf",
    txt = "text/plain",
    csv = "text/csv",
    mp3 = "audio/mpeg",
    mp4 = "video/mp4"
}
